import { Component } from "react";
import PropTypes from "prop-types";
import { Icon, Button } from "@evertrue/et-components";
import moment from "moment";
import TodoInfoArea from "apps/todo/components/todo-info-area";
import EllipsisOverflow from "components/formatting/ellipsis-overflow";
import { TodoShapePropTypes } from "apps/todo/todo-prop-types";
import TodoForm from "apps/todo/components/todo-form";
import classNames from "classnames";

class TodoItem extends Component {
  static propTypes = {
    todo: TodoShapePropTypes,
    extraClass: PropTypes.string,
    onClickListner: PropTypes.func,
    toggleDropdown: PropTypes.func,
    showInfo: PropTypes.bool,
    deleteTodo: PropTypes.func,
    editButtonClicked: PropTypes.func,
    editMode: PropTypes.bool,
    clearForm: PropTypes.func,
    updateTodo: PropTypes.func,
    reminders: PropTypes.array,
    fetchReminder: PropTypes.func,
    createReminder: PropTypes.func,
    editReminder: PropTypes.func,
    deleteReminder: PropTypes.func,
    icon: PropTypes.string,
  };

  static defaultProps = {
    todo: {},
    extraClass: "",
    toggleDropdown: () => {},
    onClickListner: () => {},
    showInfo: false,
    deleteTodo: () => {},
    editButtonClicked: () => {},
    editMode: false,
    clearForm: () => {},
    updateTodo: () => {},
    reminders: [],
    fetchReminder: () => {},
    createReminder: () => {},
    editReminder: () => {},
    deleteReminder: () => {},
    icon: "",
  };

  state = {
    checkStatusChanged: false,
  };

  checkBoxClicked = (todo) => {
    this.setState({
      checkStatusChanged: true,
    });
    //this is where the animation magic happens.
    // the the below schedule is to allow the animation to complete its course and then send out a request
    setTimeout(() => {
      this.props.onClickListner(todo);
    }, 1500);
  };

  render() {
    const {
      extraClass,
      showInfo,
      toggleDropdown,
      todo,
      deleteTodo,
      editMode,
      editButtonClicked,
      clearForm,
      updateTodo,
      fetchReminder,
      createReminder,
      editReminder,
      reminders,
      deleteReminder,
    } = this.props;

    const { summary, due_date, id } = todo;
    const month_str = moment(due_date).format("MMM");
    const day_str = moment(due_date).format("DD");
    const item_style = classNames("todo--cell", { "todo--cell-click-animate": this.state.checkStatusChanged });
    const icon = this.props.todo.completed ? "todolistcircle" : "check-circle";
    if (editMode) {
      const reminder = reminders.length > 0 ? reminders[0] : {};
      return (
        <TodoForm
          todo={todo}
          editMode={true}
          clearForm={clearForm}
          deleteTodo={deleteTodo}
          updateTodo={updateTodo}
          reminder={reminder}
          createReminder={createReminder}
          editReminder={editReminder}
          deleteReminder={deleteReminder}
        />
      );
    }
    return (
      <li className={item_style}>
        <div className="todo--cell-body">
          <Icon
            icon={this.state.checkStatusChanged ? icon : this.props.icon}
            onClick={() => this.checkBoxClicked(todo)}
          />
          <Button type="simple" title="Toggle dropdown" onClick={() => toggleDropdown(id)}>
            <EllipsisOverflow className={`todo-item--cell-text ${extraClass}`}>{summary}</EllipsisOverflow>
          </Button>
          {due_date && (
            <div className="todo-item--cell-date">
              <strong>{day_str}</strong> {month_str}
            </div>
          )}
        </div>
        {showInfo && (
          <TodoInfoArea
            todo={todo}
            deleteTodo={deleteTodo}
            editButtonClicked={editButtonClicked}
            fetchReminder={fetchReminder}
            reminders={reminders}
          />
        )}
      </li>
    );
  }
}

export default TodoItem;
